import { render, staticRenderFns } from "./SiteNavMobileV2MainNav.vue?vue&type=template&id=679541ec&scoped=true&lang=pug"
import script from "./SiteNavMobileV2MainNav.vue?vue&type=script&lang=js"
export * from "./SiteNavMobileV2MainNav.vue?vue&type=script&lang=js"
import style0 from "./SiteNavMobileV2MainNav.vue?vue&type=style&index=0&id=679541ec&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679541ec",
  null
  
)

export default component.exports